import { Button, Modal } from 'rsuite';
import { LoadingSpinerLocal } from '../components/LoadingSpinner';

const ModalConfirmation = ({ show, onCancel, title, message, onConfirm, btnConfirmClass, buttonConfirm, buttonCancel, loading = false }) => (
  <Modal backdrop="static" show={show} size="sm" onHide={onCancel}>
    <LoadingSpinerLocal loading={loading} size="md" />
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{message}</Modal.Body>
    <Modal.Footer>
      <Button onClick={onConfirm} className={btnConfirmClass} appearance="primary">
        {buttonConfirm}
      </Button>
      <Button onClick={onCancel} appearance="subtle">
        {buttonCancel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalConfirmation;
